<div>
  <div class="header">
    <div class="download">
      <a class="as-link"  (click)="downloadFile(data.src)">
        <img  src="assets/icons/download_icon.svg" alt=""/>
      </a>
      <a class="as-link"  (click)="downloadFile(data.src)">{{data.name}}</a>
    </div>

    <div class="back-action" (click)="close()">
      <mat-icon id="close-btn" class="pointer">close</mat-icon>
    </div>
  </div>
  <div class="view">
    <ng-container *ngIf="data.src" [ngSwitch]="data.type">
      <ng-container *ngSwitchCase="'video'">
        <vg-player class="flex-1">
          <video
            #media [vgMedia]="$any(media)"
            (canplay)="onCanPlay($event)"
            [vgHls]="data.src"
            preload="metadata"
            id="singleVideo"
            controls
          ></video>
        </vg-player>
        <!-- <lib-home365-video-player class="video-player" [src]="data.src"></lib-home365-video-player> -->
      </ng-container>
      <ng-container *ngSwitchCase="'pdf'">
        <div class="pdf-view">
          <lib-home365-loader *ngIf="loadingDoc" size="l"></lib-home365-loader>
          <pdf-viewer [src]="data.src"
                      [original-size]="false"
                      (on-progress)="onProgressPdf($event)"
          ></pdf-viewer>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="img-view">
          <img
            style="width: 100%; height: 100%"
            [src]="data.src"
            draggable="false" />
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>


